import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { clusterDashboardClient } from '@/api/wretch-client';

interface ICreateAuthTokenCookieParams {
  body: { encrypted_cookie: string };
  baseUrl: string;
}

export const useCreateAuthTokenCookie = (options: Pick<UseMutationOptions, 'meta'>) =>
  useMutation({
    mutationFn: ({ body, baseUrl }: ICreateAuthTokenCookieParams) => {
      const url = new URL('_auth_token', baseUrl).toString();
      return clusterDashboardClient.put(body, url).res();
    },
    ...options,
  });

export const createAuthTokenCookieFn = ({ body, baseUrl }: ICreateAuthTokenCookieParams) => {
  const url = new URL('_auth_token', baseUrl).toString();
  return clusterDashboardClient.put(body, url).res();
};
